// eslint-disable-next-line import/prefer-default-export
export const muiDialogContentComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing('LARGE'),
      paddingTop: theme.spacing('NONE'),
    }),
  },
};
